import { TransportAssoc } from "./transport-assoc";
import { PipelineFlowTransport } from "./pipeline/pipeline-flow-transport";

export class TransportServices {
  transportAssoc?: TransportAssoc;
  pipelineFlowTransport?: PipelineFlowTransport;

  cost = 0;
  loads = 0;
  qty = 0;

  static fromTta = (tta: TransportAssoc): TransportServices => {
    const ts = new TransportServices();
    ts.transportAssoc = tta;
    return ts;
  };

  static fromFlow = (flow: PipelineFlowTransport): TransportServices => {
    const ts = new TransportServices();
    ts.pipelineFlowTransport = flow;
    return ts;
  };
}
